import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import {withContext} from '../../custom/StateProvider';
import {API} from "../../../config";
import {Grid, TableFilterRow, TableHeaderRow, Table, PagingPanel} from "@devexpress/dx-react-grid-material-ui";
import {FilteringState, IntegratedFiltering, IntegratedSorting, SortingState, TableColumnResizing, PagingState, IntegratedPaging} from "@devexpress/dx-react-grid";
import Utils from "../../custom/utils";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import ViewInvestorButton from "./components/viewInvestorButton";
import NewInvestorButton from "./components/newInvestorButton";
import {connect} from "react-redux";
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

const db_utils = API.service('utils');

const styles = theme => ({
    heading1:{
        color:theme.colorPrimary
    },
    header:{
        backgroundColor:"#262933",
        padding:'18px',
        paddingTop:'17px',
        color:'white'
    },
    flex: {
      flex: 1,
    },
});

class Investors extends Component {
    state = {
        investors: [],
        columnWidths: [
          { columnName: 'acc', width:190},
          { columnName: '_name', width:250},
          { columnName: '_country', width:60},
          { columnName: '_vcontact_value_1', width:130},
          { columnName: '_email', width:240},
          { columnName: '_state', width:110},
          { columnName: '_affiliate', width:90},
          { columnName: '_poid', width:30},
          { columnName: '_poad', width:30},
          { columnName: 'USD_FREE', width:90},
          { columnName: 'EUR_FREE', width:90},
          { columnName: 'ANG_FREE', width:90},
          { columnName: 'GBP_FREE', width:90},
          { columnName: 'IPO_FREE', width:90},
          { columnName: '_actions', width:90},
        ],
        pageSizes: [20,50, 100, 200, 0],
    }

    fetchData = () => {
        const app = this;

        let query = {}

        if(this.props.user.affiliate !== null){
          console.log('wtf')
          query = {query:{_affiliate:this.props.user.affiliate}}
          console.log('query',query)
        }

        db_utils.find(query).then(inv =>{
          console.log('hmmm',inv, query)
            app.props.context.update({
              investors:inv.result
            })
            console.log(this.props);
        }).catch(e=>{
            console.log('Error Loading:', e);
            app.setState({
                error:'Error: ' + e
            })
        })
    }

    investorState(state) {
        let InvStatus = Utils.returnState(state);
        return(
          <div className={'kyc-label ' + InvStatus[0]}>{InvStatus[1]}</div>
        )
    }

    componentDidMount = () => {
        this.fetchData();
        console.log('investor',this.props);
    }

    changeColumnWidths = (columnWidths) => {
      this.setState({ columnWidths });
    };

    render() {

        const {classes} = this.props;

        return (
            <React.Fragment>

                      <AppBar position="static" elevation={0} style={{boxShadow:'none'}}>
                        <Toolbar>
                          <Typography variant="title" color="inherit" className={classes.flex}>
                            Investors
                          </Typography>
                            {(this.props.user.role.includes('super') || this.props.user.role.includes('investor_creation')) &&
                              <NewInvestorButton />
                            }
                        </Toolbar>
                      </AppBar>

                  {(this.props.context.investors !== false) &&
                    <Grid
                        rows={this.props.context.investors}
                        columns={[
                            { name: 'acc', title: 'Account' },
                            { name: '_name', title: 'Name', getCellValue: row => (row._firstname ? row._firstname + ' ' + row._surname: undefined) },
                            { name: '_country', title: 'Country' },
                            { name: '_vcontact_value_1', title: 'Mobile' },
                            { name: '_email', title: 'Email' },
                            { name: '_state', title: 'State', getCellValue: row => (row._states ? this.investorState(row._states): undefined) },
                            { name: '_affiliate', title: 'Agent'},
                            { name: '_poid', title: 'ID', getCellValue: row => ((row.poid) ? <FontAwesomeIcon icon="home" /> : <FontAwesomeIcon style={{color:'white'}} icon="home" />)},
                            { name: '_poad', title: 'Add', getCellValue: row => ((row.poad) ? <FontAwesomeIcon icon="address-card" /> : <FontAwesomeIcon style={{color:'white'}} icon="address-card" />) },
                            { name: 'USD_FREE', title: '$', getCellValue: row => ('$' + Utils.addThousandCommas((row.USD_FREE || '0.00'),'0,00'))},
                            { name: 'EUR_FREE', title: '€', getCellValue: row => ('€' + Utils.addThousandCommas((row.EUR_FREE || '0.00'),'0,00'))},
                            { name: 'ANG_FREE', title: 'ƒ', getCellValue: row => ('ƒ' + Utils.addThousandCommas((row.ANG_FREE || '0.00'),'0,00')) },
                            { name: 'GBP_FREE', title: '£', getCellValue: row => ('£' + Utils.addThousandCommas((row.GBP_FREE || '0.00'),'0,00'))},
                            { name: 'IPO_FREE', title: 'IPO', getCellValue: row => ('$' + Utils.addThousandCommas((row.IPO_FREE || '0.00'),'0,00')) },
                            { name: '_actions', title: 'Actions', getCellValue: row => (<ViewInvestorButton row={row}/>) },
                        ]}>
                          <SortingState
                            defaultSorting={[{ columnName: '_timestamp', direction: 'desc' }]}
                          />
                          <IntegratedSorting />
                          <FilteringState defaultFilters={[]} />
                          <IntegratedFiltering />
                          <PagingState
                            defaultCurrentPage={0}
                            defaultPageSize={20}
                          />
                          <IntegratedPaging />
                          <Table />
                          <TableColumnResizing defaultColumnWidths={this.state.columnWidths} />
                          <TableHeaderRow showSortingControls />
                          <TableFilterRow />
                          <PagingPanel
                            pageSizes={this.state.pageSizes}
                          />
                      </Grid>
                    }
            </React.Fragment>
        );
    }
}

function mapStateToProps({ fuse, auth }) {
  return {
    user: auth.user
  }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(connect(mapStateToProps)(Investors))));
